import ajax from 'utils/ajax';

export const getAnnouncementList = (params: any) =>
  ajax({
    url: 'outsource/v2/java_proxy/bidding/workbenches/announcement/list',
    method: 'POST',
    body: params,
  });

export const getAnnouncementDetail = (id: number) =>
  ajax({
    url: `outsource/v2/java_proxy/bidding/workbenches/announcement/can_modify/get?id=${id}`,
    method: 'POST',
  });

export const updateAnnouncementList = (params: any) =>
  ajax({
    url: 'outsource/v2/java_proxy/bidding_move/move',
    method: 'POST',
    body: params,
  });

export const getOptions = (params: any) =>
  ajax({
    url: 'outsource/v2/java_proxy/common/filter_options',
    method: 'POST',
    body: params,
  });
